var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAssistance = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 60,
  height: 60,
  fill: "none"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 30,
  cy: 30,
  r: 30,
  fill: "#fff",
  opacity: 0.55
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeWidth: 1.2,
  d: "M13 22.83a2 2 0 0 1 2-2h30a2 2 0 0 1 2 2v5.254A2 2 0 0 1 45.575 30l-14.426 4.327a4 4 0 0 1-2.298 0L14.425 30A2 2 0 0 1 13 28.084z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.2,
  d: "M30 29.572v-2.914"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  stroke: "#472179",
  strokeWidth: 1.2,
  d: "M14.418 29.571V41.6a4 4 0 0 0 4 4h23.167a4 4 0 0 0 4-4V29.57M35.665 20.829V17a2 2 0 0 0-2-2h-7.333a2 2 0 0 0-2 2v3.828"
})));
export default SvgAssistance;